import { Button, Col, Pagination, Row, Space, Table } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { BiRefresh } from 'react-icons/bi';
import styled from 'styled-components';
import { ITable } from '../../model/TableModel';
import { NAV_HEADER_HEIGHT, TABLE_HEADER_HEIGHT } from '../../utils/app-common';


const TableDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

const TableComponent = ({
    columns,
    data,
    title,
    isLoading,
    onPaginationChange,
    onShowSizeChange,
    onRowSelect,
    scroll = { y: 510, x: 1500 },
    rowSelection,
    showRowSelection = false,
    pageNumber = 0,
    total = 0,
    current,
    children,
    rowKey = 'id',
    className,
    onRefreshHandle,
    isRefresh = true,
    hideOnSinglePage = false,
    components = undefined,
    expandable,
    size = 'middle',
    rowClassName,
    indentSize = 0,
    paginationDisabled = false,
    pageSize = 20,
    showSizeChanger = false,
    pageSizeOptions = ["10", "20", '30', '50'],
    showTotal,
    clientPagination = false,
    toolbarExtra,
    ...props
}: ITable) => {

    const [tableHeight, setTableHeight] = useState(750);
    // ref is the Table ref.
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const node = ref?.current;
        const { top } = node?.getBoundingClientRect()! || {};
        setTableHeight((window.innerHeight - top - (NAV_HEADER_HEIGHT + TABLE_HEADER_HEIGHT)) || 510);
    }, [ref]);

    return (
        <TableDiv>
            <Row justify='end' gutter={6} align={'middle'}>
                <Space align='center' direction='horizontal' size={2}>
                    {children}
                </Space>
                <Col>
                    {isRefresh ?
                        <Button loading={isLoading} type='default' onClick={onRefreshHandle}
                            icon={<BiRefresh size={18}></BiRefresh>} />
                        : null}
                </Col>
            </Row>
            {toolbarExtra}
            <Table
                {...props}
                className={className}
                components={components}
                rowClassName={rowClassName}
                sticky
                rowKey={data => data[rowKey]}
                key={rowKey}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: () => onRowSelect?.(record, rowIndex), // click row
                    };
                }}
                indentSize={indentSize}
                rowSelection={showRowSelection ? {
                    type: 'checkbox',
                    ...rowSelection,
                } : undefined}
                columns={columns}
                dataSource={data}
                loading={isLoading}
                size={size}
                scroll={scroll?.x ? { x: scroll.x } : undefined} // only horizontal scroll
                pagination={clientPagination ? {
                    defaultPageSize: pageSize,
                    showSizeChanger: true,
                    pageSizeOptions,
                    showTotal: (count, range) => `${range[0]}-${range[1]} of ${count}`,
                    position: ['bottomLeft'],
                } : false}
                expandable={expandable}
            />
            {clientPagination ? null : <Pagination
                // current={current ?? 1}
                disabled={paginationDisabled}
                hideOnSinglePage={hideOnSinglePage}
                onChange={onPaginationChange}
                total={total}
                defaultCurrent={current ?? 1}
                current={current ?? 1}
                showSizeChanger={showSizeChanger}
                showTitle={false}
                pageSizeOptions={pageSizeOptions}
                showTotal={showTotal}
                onShowSizeChange={onShowSizeChange}
                {...(pageSize ? { pageSize } : {})}
                size={'default'}
            />}
        </TableDiv>
    )
}

export default TableComponent